<template>
  <div class="layout">
    <div class="main-content">
      <router-view />
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue"; // 请确保路径正确
// import ZE from '@/components/zh_en.vue'
import { addVisitRecord } from "@/utils/visitRecord.js";
export default {
  components: {
    Footer,
  },
  mounted() {
    // 组件挂载完成后执行
    addVisitRecord({
      where: "guanwang",
      visitTime: this.getCurrentTime(),
    })
      .then((res) => {
        console.log("访问记录添加成功", res);
      })
      .catch((err) => {
        console.error("访问记录添加失败", err);
      });
    console.log("123");
    // 这里可以写你想在 mounted 里执行的代码，比如请求接口等
  },
  methods: {
    getCurrentTime(){
      const date = new Date();
      const pad = (n) => n.toString().padStart(2, "0");

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh; // 关键：布局高度至少是视口高度
}

.main-content {
  flex: 1; // 中间内容自动撑满
}
</style>